import React, { useContext, useState, useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { AuthContext } from 'context/Auth';
import {
  AuthContainer, AuthFormContainer,
  AuthImageContainer, AuthFormContent,
  AuthFormTitle, AuthFormText,
  ButtonsBox,
} from 'styles/AuthStyles';
import LoginPortrait from 'components/LoginPortrait';
import EmailInput from 'components/Input/Email';
import Button from 'components/Button';
import Loading from 'components/Loading';
import ErrorBox from 'components/ErrorBox';
import LogoLink from 'components/LogoLink';

const testEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

function ForgotPasswordPage() {
  const { submitResetPassword, loginContent, clearAuthContext } = useContext(AuthContext);
  const [validEmail, setValidEmail] = useState();
  const [validForm, setValidForm] = useState();
  const [email, setEmail] = useState();
  const [response, setResponse] = useState({});

  const { loading } = loginContent;

  useEffect(() => {
    return function cleanup() {
      clearAuthContext();
    };
  }, []);

  useEffect(() => {
    if (email && email.length > 5) {
      setValidEmail(testEmail.test(email));
    } else {
      setValidEmail(false);
    }
  }, [email]);

  useEffect(() => {
    if (email && validEmail) {
      setValidForm(true);
    } else {
      setValidForm(false);
    }
  }, [email, validEmail]);

  const onSubmit = async (e) => {
    e.preventDefault();

    const result = await submitResetPassword({
      email,
    });

    setResponse({
      ...result,
    });
  }

  return (
    <AuthContainer>
      {response.success && <Redirect to="/recuperacao-de-senha" />}
      <Loading show={loading} size="big" />
      <AuthFormContainer>
        <AuthFormContent>
          <LogoLink variant="inverse" />
          <AuthFormTitle>Recuperar Senha</AuthFormTitle>
          <AuthFormText>Digite seu e-mail e receberá um código de recuperação no celular ou e-mail.</AuthFormText>
          {response.success === false && (
            <ErrorBox>{response.message}</ErrorBox>
          )}
          <form noValidate onSubmit={onSubmit} autoComplete="off">
            <EmailInput
              id="email"
              name="email"
              onChange={(e) => {
                setEmail(e.target.value);
              }}
            />
            <ButtonsBox>
              <Button
                label="Enviar"
                disabled={!validForm}
              />
            </ButtonsBox>
          </form>
        </AuthFormContent>
      </AuthFormContainer>
      <AuthImageContainer>
        <LoginPortrait />
      </AuthImageContainer>
    </AuthContainer>
  );
}

export default ForgotPasswordPage;
